<div class="map-type-button-container" (click)="emitToggle()" [class.black-border]="viewType === satelliteView">
  <div
    *ngIf="viewType !== satelliteView"
    class="image-container"
    [soti-tooltip]="'map_type_satellite_view' | xsI18n"
    placement="left"
    delay="500"
  >
    <img src="assets\images\Map-Satellite-View.png" />
  </div>
  <div
    *ngIf="viewType === satelliteView"
    class="image-container"
    [soti-tooltip]="'map_type_roadmap_view' | xsI18n"
    placement="left"
    delay="500"
  >
    <img src="assets\images\Map-Roadmap-View.png" />
  </div>
</div>
